import React, { FC } from 'react'
import { createStyles, makeStyles } from 'transfix-ui/core'
import { IConnectionConfigTypes, IConnectionTypes } from 'types/graphqlTypes'
import { Button } from 'transfix-ui'
import { useTestConnectionConfig } from './hooks/useTestConnectionConfig'

interface ITestConnectionConfigProps {
  connectionConfigType: IConnectionConfigTypes
  connectionType: IConnectionTypes | undefined
  configId: string | null
}

const useTestConnectionConfigStyles = makeStyles(({ spacing }) =>
  createStyles({
    root: {
      marginLeft: spacing(4),
    },
  })
)

export const TestConnectionConfig: FC<ITestConnectionConfigProps> = ({
  configId,
  connectionConfigType,
  connectionType,
}) => {
  const classes = useTestConnectionConfigStyles()

  const { testAs2ConnectionConfig, testFtpConnectionConfig } = useTestConnectionConfig()

  if (configId === null) {
    return null
  }

  const clickHandler = () => {
    if (connectionType === IConnectionTypes.AS2) {
      testAs2ConnectionConfig({ id: configId })
    } else {
      testFtpConnectionConfig({
        ediMapperConnectionConfigId: configId,
        ediMapperConnectionConfigType: connectionConfigType,
      })
    }
  }

  return (
    <div className={classes.root}>
      <Button color='primary' size='small' data-test='test-config-button' onClick={clickHandler}>
        Test Connection
      </Button>
    </div>
  )
}
